import { createStore } from 'jotai'
import { isSaveLastUrlAtom } from '@!/atoms/appSettingsAtom'
import { paymentListAtom, monthlyCoursesAtom, tokenApiUrlAtom, shopIdAtom } from '@!/atoms/paymentAtom'

export const usePaymentSettings = ({ isSaveLastUrl, paymentList, monthlyCourses, tokenApiUrl, shopId }) => {
  const store = createStore()
  store.set(isSaveLastUrlAtom, isSaveLastUrl)
  store.set(paymentListAtom, paymentList)
  store.set(monthlyCoursesAtom, monthlyCourses)
  store.set(tokenApiUrlAtom, tokenApiUrl)
  store.set(shopIdAtom, shopId)

  return store
}
